<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card class="elevation-12">
      <v-toolbar dark color="mdred ">
        <v-toolbar-title>{{ $t("app.login.title") }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          v-model="email"
          prepend-icon="person"
          :rules="$rules('user.email')"
          :label="$t('user.fields.email')"
          required
        ></v-text-field>

        <v-text-field
          v-model="password"
          prepend-icon="lock"
          :append-icon="show ? 'visibility' : 'visibility_off'"
          :type="show ? 'text' : 'password'"
          :rules="$rules('user.password')"
          :label="$t('user.fields.password')"
          required
          @click:append="show = !show"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-layout row wrap>
            <v-flex v-if="message !== ''" xs12>
              <div :class="messageType">
                {{ message }}
              </div>
            </v-flex>
            <v-flex xs12>
              <div class="forgot-password">
                <a :href="apiUrl + '/password/reset'">{{
                  $t("app.login.forgot-pass")
                }}</a>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          :disabled="!valid"
          dark
          color="mdred lighten-1 "
          @click="login"
        >
          {{ $t("app.login.action") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { i18n } from "@/services/vue-i18n";

export default {
  data: () => ({
    valid: true,
    email: "",
    password: "",
    show: false,
    message: "",
    messageType: "error",
    apiUrl: process.env.VUE_APP_API
  }),

  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.message = "";
        this.$store
          .dispatch("site/login", {
            email: this.email.trim(),
            password: this.password
          })
          .then(response => this.successLogin(response))
          .catch(error => this.errorLogin(error));
      }
    },

    // eslint-disable-next-line no-unused-vars
    successLogin(res) {},

    errorLogin(error) {
      if (process.env.NODE_ENV !== "production") {
        console.log(error);
      }
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "error",
          message: i18n.t("app.actions.failed.login")
        },
        { root: true }
      );
    }
  }
};
</script>
